/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

// ************************* Libreria para realizar pdfs *************************/
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

// ------------------ COMPONENTES DE BASE--------------------------
import { formatNumberDecimal } from "../../../../../Base/Services/FormatTemplate";
import { getLabel } from "../../../../../Base/Services/Language/LanguageService";
import { getLocalDateString } from "../../../../../Base/Services/FechasService";
import { getDateString } from "../../../../../Base/Services/Moment/Luxon";
import { getInformacionEmpresa } from "../../../../../Base/API/Global/InformacionEmpresa/InformacionEmpresaRequest";

// ------------------- CONSULTAS A LA API---------------------------
import { obtenerDetalleOrdenSinCancelar, obtenerOrdenCompra } from "../../../../../API/Compras/Ordenes/OrdenesComprasRequests";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import { OrdenesComprasReporteLang } from "./OrdenesComprasLang";
import QRCode from 'qrcode';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const OrdenesComprasReporte = () => {
  const { IdOrden } = useParams();
  const {Idioma} = useParams();
  const [encabezado, setEncabezado] = useState(null);
  const [orderDetalle, setOrderDetalle] = useState([]);

  const [idOrder, setIdOrder] = useState(0);
  const [infoEmpresa, setInfoEmpresa] = useState([]);
  const [idioma, setIdioma] = useState(2);

  const obtenerInformacion = async (IdOrden, Idioma) => {
    const tempoEncabezado = await obtenerOrdenCompra(IdOrden);
    setEncabezado(tempoEncabezado[0]);


    const agruparDetalles = (detalles) => {
      const groupedDetails = {};
  
      // Agrupar los detalles por IdProduct y Price
      detalles.forEach(detalle => {
          const { IdComponent, Price, UnitPrice } = detalle;
          // Crear una clave única usando IdProduct y Price
          const key = `${IdComponent}-${Price}`;
  
          if (groupedDetails[key]) {
              // Si la clave ya existe, sumar la Quantity
              groupedDetails[key].Quantity += UnitPrice;
          } else {
              // Si la clave no existe, crear una nueva entrada
              groupedDetails[key] = { ...detalle };
          }
      });
  
      // Convertir el objeto agrupado en un arreglo y devolverlo
      return Object.values(groupedDetails);
    };

    const tempoDetalles = await obtenerDetalleOrdenSinCancelar(IdOrden);
    const detallesAgrupados = agruparDetalles(tempoDetalles);
    setOrderDetalle(tempoDetalles);

    const purchaseRequests = tempoDetalles .map(detalle => detalle.PurchaseRequest).join(',  ')

    const infoEmpresaTempo = await getInformacionEmpresa()
    setInfoEmpresa(infoEmpresaTempo)

    let name = infoEmpresaTempo[0].NombreLegal
    let direccion = infoEmpresaTempo[0]?.Direccion
    let RTNEmpresa = infoEmpresaTempo[0]?.RTN
    let logoB64 = infoEmpresaTempo[0]?.LogoPrimarioB64
    
    let IdLanguage = Number(Idioma)
    generarPDF(tempoEncabezado[0], detallesAgrupados, IdLanguage, name, direccion, logoB64, RTNEmpresa, purchaseRequests);
  };

  useEffect(() => {
    if (IdOrden) {
      obtenerInformacion(IdOrden, Idioma);
      setIdOrder(IdOrden);
      setIdioma(Idioma)
    }
  }, [IdOrden, Idioma]);


  const calcularCantidadTotal = (listadoDetalles) => {
    let cantidadTot = 0;
    listadoDetalles.forEach((detalle) => {
      cantidadTot += detalle.Quantity;
    });
    return cantidadTot;
  };

  const calcularCantidadProductos = (listadoDetalles) => {
    const idProductsSet = new Set();
    listadoDetalles.forEach((detalle) => {
      idProductsSet.add(detalle.IdProduct);
    });
    return idProductsSet.size;
  };

  const obtenerImagenPDF = (img) => {
    if (!img || typeof img !== "string") return null;

    const limpia = img.trim();

    if (!limpia) return null;

    if (limpia.startsWith("data:image/")) {
      return limpia;
    }

    return `data:image/png;base64,${limpia}`;
  };

  const generarPDF = async (data, listadoDetalles, Idioma, name, direccion, logoB64, RTNEmpresa, purchaseRequests) => {
    let Language = Idioma === 1? 'en' : 'es'
    const logoPDF = obtenerImagenPDF(logoB64);
    let CodigoQR =
    console.log(QRCode);
    QRCode.toDataURL(`${data.PurchaseOrder}`, { errorCorrectionLevel: 'Q' }, (err, url) => {
      console.log(url, err);
      CodigoQR = url;
    })


    const cantidadTot = calcularCantidadTotal(listadoDetalles);
    const cantidadProductos = calcularCantidadProductos(listadoDetalles);

    const monedas = [
      ...new Set(listadoDetalles.map((detalle) => detalle.CurrencySymbol)),
    ];

    const docDefinition = {
      pageSize: "LETTER",
      pageOrientation: "portrait",
      pageMargins: [35, 85, 30, 95],

      header: function (currentPage, pageCount, pageSize) {
        return [
          {
            columns: [
              logoPDF
                ? {
                    image: logoPDF,
                    width: 200,
                    margin: [4, -10, -10, -10],
                  }
                : {
                    text: "",
                    width: 200,
                    margin: [4, -10, -10, -10],
                  },

              [
                {
                  text: name,
                  style: "titulo2",
                  margin: [-10, 30, 0, 0],
                  width: 350,
                },
                {
                  text: direccion,
                  style: "titulo",
                  margin: [-10, 5, 0, 0],
                  width: 350,
                },
              ],
              [
                {
                  text: `${getLabel(
                    OrdenesComprasReporteLang,
                    "TituloReporte",
                    Language
                  )} \n ${data?.PurchaseOrder || ""}`,
                  style: "numeroDoc",
                  width: 100,
                  margin: [0, 35, 0, 0],
                },
              ],
            ],
          },
        ];
      },

      footer: (currentPage, pageCount) => {
        return {
          table: {
            widths: [450, 150],
            body: [
              [
                {
                  text:
                    `${purchaseRequests}`
                    + "\n\n" +
                    `${getLabel(
                      OrdenesComprasReporteLang,
                      "fecha",
                      Language
                    )}` + getLocalDateString(new Date())
                    + "\n\n" +
                    `${getLabel(
                      OrdenesComprasReporteLang,
                      "original",
                      Language
                    )}`
                    + "\n\n" +
                    `${getLabel(
                      OrdenesComprasReporteLang,
                      "copia",
                      Language
                    )}\n\n` +
                    `${getLabel(
                      OrdenesComprasReporteLang,
                      "textFinal",
                      Language
                    )}\n\n`
                  ,
                  margin: [30, -20, 5, 0],
                  fontSize: 7.5,
                },
                {
                  image: CodigoQR,
                  width: 70,
                  margin: [0, -15, 30, 0],
                  alignment: "right",
                },
              ],
              [
                {
                  image: CodigoQR,
                  width: 70,
                  margin: [0, -15, 30, 0],
                  alignment: "right",
                },
                {
                  text: `${getLabel(
                    OrdenesComprasReporteLang,
                    "Pagina",
                    Language
                  )} ${currentPage} / ${pageCount}`,
                  margin: [30, -20, -20, 0],
                  fontSize: 7.5,
                },
              ],
            
            ],
          },
          layout: {
            fillColor: function (rowIndex, node, columnIndex) {
              return rowIndex % 2 === 0 ? "#FFFFFF" : null;
            },
            defaultBorder: false,
          }
        };
      },
      
      content: [
        {
          columns: [
            {
              margin: [0, 0, 0, 0],

              table: {
                widths: [400, '*'],
                body: [
                  [
                    {
                      text: `${getLabel(OrdenesComprasReporteLang,"fecha",Language)} ${getDateString(new Date())}`,
                      border: [false, false, false, false],
                      style: "infoGeneral",
                    },
                    {
                      text: `RTN: ${RTNEmpresa}`,
                      border: [false, false, false, false],
                      style: "infoGeneralRTN",
                    },
                  ],
                ],
              },
            },
          ],
        },
        {
          columns: [
            {
              margin: [0, 0, 0, 10],

              table: {
                widths: [532],
                body: [
                  [
                    {
                      text: `${getLabel(OrdenesComprasReporteLang,"direccionE",Language)} ${data?.AddressCustomer || ""}`,
                      style: "infoGeneral",
                      border: [false, false, false, true],
                    },
                  ],
                ],
              },
            },
          ],
        },
        {
          table: {
            margin: [0, 15, 0, 10],
            widths: [263, 263],
            body: [
              [
                { text: `${getLabel(OrdenesComprasReporteLang,"proveedor",Language)}`, style: "subtitle", border: [true, true, true, false] },
                { text: `${getLabel(OrdenesComprasReporteLang,"envioA",Language)}`, style: "subtitle", border: [false, true, true, false]  },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i) {
              return 0.05; // Establecer grosor de línea horizontal
            },
            vLineWidth: function (i) {
              return 0.05; // Establecer grosor de línea vertical
            },
            hLineColor: function (i) {
              return "#aaa"; // Color de las líneas horizontales
            },
            vLineColor: function (i) {
              return "#aaa"; // Color de las líneas verticales
            },
          },
        },
        {
          table: {
            margin: [0, 15, 0, 10],
            widths: [40,215, 40,215],
            body: [
              [
                { text: `${getLabel(OrdenesComprasReporteLang,"nombre",Language)}`, style: "subtitle2", border: [true, false, false, false] }, 
                { text: `${data?.Expr1 || ""}`, style: "infoProveedor", border: [false, false, false, false] }, 
                { text: `${getLabel(OrdenesComprasReporteLang,"nombre",Language)}`, style: "subtitle2", border: [true, false, false, false] },
                { text: `${data?.CustomerName || ''}`, style: "infoProveedor", border: [false, false, true, false] }
              ],
              [
                { text: `Attn: `, style: "subtitle2", border: [true, false, false, false] }, 
                { text: ``, style: "infoProveedor", border: [false, false, false, false] }, 
                { text: `Attn:`, style: "subtitle2", border: [true, false, false, false] },
                { text: `${data?.UserNameAgente ||''}`, style: "infoProveedor", border: [false, false, true, false] }
              ],
              [
                { text: `${getLabel(OrdenesComprasReporteLang,"direccion",Language)}`, style: "subtitle2",border: [true, false, false, false] }, 
                { text: `${data?.DireccionVendor ||''}`, style: "infoProveedor", border: [false, false, false, false] }, 
                { text: `${getLabel(OrdenesComprasReporteLang,"direccion",Language)}`,style: "subtitle2", border: [true, false, false, false] },
                { text: `${data?.AddressCustomer || ""}`, style: "infoProveedor", border: [false, false, true, false] }
              ],
              [
                { text: `${getLabel(OrdenesComprasReporteLang,"telefono",Language)} `, style: "subtitle2",border: [true, false, false, true] }, 
                { text: ` ${data?.Telefono || ""}`, style: "infoProveedor", border: [false, false, false, true] }, 
                { text: `${getLabel(OrdenesComprasReporteLang,"telefono",Language)}`, style: "subtitle2", border: [true, false, false, true] },
                { text: `${data?.TelefonoCustomer ||""}`, style: "infoProveedor", border: [false, false, true, true] }
              ],
            ],
          },
          layout: {
            hLineWidth: function (i) {
              return 0.05; // Establecer grosor de línea horizontal
            },
            vLineWidth: function (i) {
              return 0.05; // Establecer grosor de línea vertical
            },
            hLineColor: function (i) {
              return "#aaa"; // Color de las líneas horizontales
            },
            vLineColor: function (i) {
              return "#aaa"; // Color de las líneas verticales
            },
          },
        },
        {
          margin: [0, 20, 5, 5],
          table: {
            widths: [25, 24, 35, 98, 100, 32, 32, 32, 37],
          
            body: [
              [
                { text: `${getLabel(OrdenesComprasReporteLang,"cantidad",Language)}`, style: "header" },
                { text: `${getLabel(OrdenesComprasReporteLang,"unidad",Language)}`, style: "header" },
                { text: `${getLabel(OrdenesComprasReporteLang,"codigo",Language)}`, style: "header" },
                { text: `${getLabel(OrdenesComprasReporteLang,"producto",Language)}`, style: "header" },
                { text: `${getLabel(OrdenesComprasReporteLang,"descripcion",Language)}`, style: "header" },
                { text: `${getLabel(OrdenesComprasReporteLang,"precio",Language)}`, style: "header" },
                { text: `${getLabel(OrdenesComprasReporteLang,"isv",Language)}`, style: "header" },
                { text: `${getLabel(OrdenesComprasReporteLang,"descuento",Language)}`, style: "header" },
                { text: `SUBTOTAL`, style: "header" },
              ],
              ...listadoDetalles.map(d =>
                [
                  { text: formatNumberDecimal(`${d.Quantity || ""}`), style: 'textBody1' },
                  { text: `${d.UnitSimbol || ""}`, style: 'textBody1' },
                  { text: `${d.CodigoProducto || ""}`, style: 'textBody1' },              
                  { text: `${d.NombreProducto || ""}`, style: 'textBody3' },              
                  { text: `${d.Description || ""}`, style: 'textBody3' },
                  { text: formatNumberDecimal(`${d.UnitPrice || ""}`), style: 'textBody2' },
                  { text: formatNumberDecimal(`${d.TAX || ""}`), style: 'textBody2' },
                  { text: formatNumberDecimal(`${d.Discount || ""}`), style: 'textBody2' },
                  { text: formatNumberDecimal(`${d.SubTotal || ""}`), style: 'textBody2' },
                ],
              )          
            ],
          },
          layout: 'lightHorizontalLines'
        },


        {
          margin: [3, 3, 5, 5],
          table: {
            widths: [30, 25, 90, 147, 35, 35, 35, 70],
            body: [
              [
                {
                  text: formatNumberDecimal(`${cantidadTot}`),
                  style: "headerr",
                  border: [false, true, false, false],
                },
                {
                  text: ``,
                  style: "header",
                  border: [false, true, false, false],
                },
                {
                  text: formatNumberDecimal(`${cantidadProductos}`),
                  style: "headerr",
                  border: [false, true, false, false],
                  margin:[10,0,0,0]
                },
                {
                  text: ``,
                  style: "header",
                  border: [false, true, false, false],
                },
                {
                  text: ``,
                  style: "header",
                  border: [false, true, false, false],
                },
                {
                  text: ``,
                  style: "header",
                  border: [false, true, false, false],
                },
                {
                  text: ``,
                  style: "header",
                  border: [false, true, false, false],
                },
                {
                  text: ``,
                  style: "header",
                  border: [false, true, false, false],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i) {
              return 0.05; // Establecer grosor de línea horizontal
            },

            hLineColor: function (i) {
              return "#aaa"; // Color de las líneas horizontales
            },
          },
        },




        
        {
          margin: [0, 10, 5, 10],
          table: {
            widths: [390, 50, 15,60],
            body:
              [
                  [
                    { text: ``, style: 'textCentrado', border: [false, false, false, false], width:[340] },
                    { text: 'SubTotal', style: 'textTotales' },
                    {text:`${monedas}`,border: [false, true, false, true],style: 'textTotales' },
                    { text: formatNumberDecimal(`${data?.SubTotal || ''}`), border: [false, true, true, true],style: 'textTotales'  },
                  ],
                  [
                    { text: ``, rowSpan: 2, border: [false, false, false, false], style: 'textCentrado',width:[340] },
                    { text: `${getLabel(OrdenesComprasReporteLang,"desc",Language)}`, style: 'textTotales' },
                    {text: `${monedas}`,border: [false, true, false, true],style: 'textTotales' },
                    { text: formatNumberDecimal(`${data?.Discount || ""}`), style: 'textTotales',border: [false, true, true, true] },
                  ],
                  [
                    { text: '',style: 'textCentrado', border: [false, false, false, false]},
                    { text: `${getLabel(OrdenesComprasReporteLang,"isv",Language)}`, style: 'textTotales' },
                    {text:`${monedas}`,border: [false, true, false, true],style: 'textTotales'},
                    { text: formatNumberDecimal(`${data?.TAX || ""}`), style: 'textTotales',border: [false, true, true, true] },
                  ],
                  [
                    { text: '',style: 'textCentrado', border: [false, false, false, false]},
                    { text: `${getLabel(OrdenesComprasReporteLang,"fletes",Language)}`, style: 'textTotales' },
                    {text:`${monedas}`,border: [false, true, false, true],style: 'textTotales'},
                    { text: formatNumberDecimal(`${data?.Freights  || ""}`), style: 'textTotales',border: [false, true, true, true] },
                  ],
                  [
                    { text: '',style: 'textCentrado', border: [false, false, false, false] },
                    { text: `${getLabel(OrdenesComprasReporteLang,"otros",Language)}`, style: 'textTotales' },
                    {text:`${monedas}`,border: [false, true, false, true],style: 'textTotales'},
                    { text: formatNumberDecimal(`${data?.Otros  || ""}`), style: 'textTotales',border: [false, true, true, true] },
                  ],
                  [
                    { text: '',style: 'textCentrado', border: [false, false, false, false] },
                    { text: 'Total', style: 'textTotales' },
                    {text:`${monedas}`,border: [false, true, false, true],style: 'textTotales'},
                    { text: formatNumberDecimal(`${data?.Total || ""}`), style: 'textTotales',border: [false, true, true, true] },
                  ], 
              ]
          },
          layout: {
            hLineWidth: function (i) {
              return 0.05; // Establecer grosor de línea horizontal
            },
            vLineWidth: function (i) {
              return 0.05; // Establecer grosor de línea vertical
            },
            hLineColor: function (i) {
              return "#aaa"; // Color de las líneas horizontales
            },
            vLineColor: function (i) {
              return "#aaa"; // Color de las líneas verticales
            },
          },
        },
        {
          margin: [0, 10, 5, 5,5],
          table: {
            widths: [390, 50,50],
            body:
              [

                [
                  { text: `${getLabel(OrdenesComprasReporteLang,"terminosPago",Language)} ${data?.TerminoPago || ""}`, style: 'textBody3', border: [false, false, false, false], width:[340] },
                ],
                [
                  { text: `${getLabel(OrdenesComprasReporteLang,"terminosInco",Language)}  ${data?.TerminoInco || ""}`, border: [false, false, false, false], style: 'textBody3',width:[340] },
                ],
                [
                  { text: `${getLabel(OrdenesComprasReporteLang,"comentario",Language)}  ${data?.Description || ""}`, border: [false, false, false, false], style: 'textBody3',width:[340] },
                ],
              ]
          },
        },
        {
          columns: [
            {
                margin: [0, 100, 0, 0],
    
                table: {
                    widths: [150, 20, 150, 20, 150],
                    body: [
                        [
                            { text: '', border: [false, false, false, false] },
                            { text: '', border: [false, false, false, false] },
                            { text: '', border: [false, false, false, true] },
                            { text: '', border: [false, false, false, false] },
                            { text: '', border: [false, false, false, false] },
                        ],
                        [
                            {
                              border: [false, false, false, false],
                              text: '', width: [120]
                            },
                            {
                                border: [false, false, false, false],
                                text: '', width: [100]
                            },
                            {
                                border: [false, true, false, false],
                                text: `${getLabel(OrdenesComprasReporteLang,"deptoCompras",Language)}`,
                                style: 'firmas', width: [120]
                            },
                            {
                              border: [false, false, false, false],
                              text: '', width: [120]
                            },
                            {
                              border: [false, false, false, false],
                              text: '', width: [120]
                            },
                        ]
    
                    ]
                }
            }
        ]
        },

      ],

      styles: {
        tableExample: {
          margin: [0, 5, 0, 15],
        },
        titulo: {
          fontSize: 8,
          // margin: [0, 50, 0, 0],
          bold: true,
          alignment: "justify",
        },
        titulo2: {
          fontSize: 9,
          // margin: [0, 50, 0, 0],
          bold: true,
          alignment: "justify",
        },
        requisa: {
          fontSize: 15,
          // margin: [0, 50, 0, 0],
          bold: true,
          alignment: "justify",
        },
        numeroDoc: {
          fontSize: 12,
          bold: true,
          alignment: "center",
        },
        subtitle: {
          fontSize: 8,
          bold: true,
          alignment: "center",
        },
        subtitle2: {
          fontSize: 8,
          bold: true,
        },
        infoGeneral: {
          fontSize: 8,
          margin: [-5, 0, 0, 0],
          // bold: true,
          // alignment: 'justify'
        },
        infoGeneralRTN: {
          fontSize: 8,
          margin: [-5, 0, 0, 0],
          // bold: true,
          alignment: 'right'
        },
        infoProveedor: {
          fontSize: 8,
          margin: [0, 0, 0, 0],
        },
        header: {
          fontSize: 6.5,
          alignment: "center",
          bold: true,
        },
        headerr: {
          fontSize: 7,
          margin: [-5, 0, 0, 0],
        },
        textBody1: {
          fontSize: 7.5,
          alignment: "center",
          // lineHeight: 2
        },
        textBody2: {
          fontSize: 7.5,
          alignment: "right",
          // lineHeight: 2
        },
        textBody3: {
          fontSize: 7.5,
          alignment: "justify",
          // lineHeight: 2
        },
        textBody4: {
          fontSize: 8.5,
          alignment: "justify",
          // lineHeight: 2
        },
        textTotales: {
          bold: true,
          fontSize: 7.5,
          alignment: "right",
        },
        textCentrado: {
          fontSize: 7.5,
          alignment: "center",
        },
        firmas: {
          fontSize: 8,
          bold: true,
          alignment: "center",
          lineHeight: 1,
        },
        footer: {
          fontSize: 7.5,
          alignment: "left",
          margin: [30, 0, 5, 0],
        },
      },
    };

    pdfMake.createPdf(docDefinition).open({}, window);
  };
};

export default OrdenesComprasReporte;
